<template>
    <div class="pack-go-bg">
        <section>
            <Nav />
            <AutomaticModeComponent />
        </section>
        <!-- <InstructionsBar v-if="displayInstructionBar"/> -->
    </div>
</template>

<script>
import InstructionsBar from "@/components/InstructionsBar.vue";
import AutomaticModeComponent from "@/components/Picking/AutomaticMode.vue";
import Nav from "@/components/Picking/Nav.vue";

    export default {
        name: 'AutomaticMode',
        props: ['displayInstructionBar'],
        components: {
            Nav,
            InstructionsBar,
            AutomaticModeComponent
        }
    }
</script>

<style>
    .pack-go-bg {
        background-color: #F4FAFF;
        min-height: 100vh;
    }
</style>